// Hjälpfunktioner för native HTML5 drag-and-drop i designläget.
//
// Två sorters drag förekommer:
//  1) NEW   — paletten släpper in en ny blocktyp på canvas.
//  2) MOVE  — ett existerande block flyttas till en annan position på canvas.
//
// Vi använder två separata MIME-typer i dataTransfer för att skilja dem åt.
// Egna MIME-typer (x-fs-*) gör så att webbläsaren inte tolkar payloaden som
// text och dropEffect/effectAllowed sätts rätt.

import { BlockId, BlockType } from './types';

export const MIME_NEW = 'application/x-fs-block-new';
export const MIME_MOVE = 'application/x-fs-block-move';

export type DragPayload = { kind: 'new'; blockType: BlockType } | { kind: 'move'; blockId: BlockId };

// Läser ut payload från ett DragEvent. Returnerar null om datan inte är ett
// av våra format (t.ex. text-drag från andra appar).
export const readDragPayload = (e: React.DragEvent): DragPayload | null => {
  const { types } = e.dataTransfer;
  if (types.includes(MIME_NEW)) {
    const blockType = e.dataTransfer.getData(MIME_NEW) as BlockType;
    if (blockType) return { kind: 'new', blockType };
  }
  if (types.includes(MIME_MOVE)) {
    const blockId = e.dataTransfer.getData(MIME_MOVE);
    if (blockId) return { kind: 'move', blockId };
  }
  return null;
};

// True om DragEvent bär ett av våra format. Snabbare än readDragPayload när
// vi bara behöver veta om dragOver/drop ska accepteras (getData fungerar inte
// under dragOver i alla webbläsare — bara types).
export const hasDragPayload = (e: React.DragEvent): boolean => {
  const { types } = e.dataTransfer;
  return types.includes(MIME_NEW) || types.includes(MIME_MOVE);
};
